/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Max_CharsInputs */

const en_live_caption_max_chars = /** @type {(inputs: Live_Caption_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max characters per line`)
};

const fr_live_caption_max_chars = /** @type {(inputs: Live_Caption_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre maximal de caractères par ligne`)
};

const de_live_caption_max_chars = /** @type {(inputs: Live_Caption_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Zeichen pro Zeile`)
};

const it_live_caption_max_chars = /** @type {(inputs: Live_Caption_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero massimo di caratteri per riga`)
};

const ru_live_caption_max_chars = /** @type {(inputs: Live_Caption_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальное количество символов в строке`)
};

const es_live_caption_max_chars = /** @type {(inputs: Live_Caption_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de caracteres por línea`)
};

const zh_cn2_live_caption_max_chars = /** @type {(inputs: Live_Caption_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每行最多字符数`)
};

const ja_live_caption_max_chars = /** @type {(inputs: Live_Caption_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1行あたりの最大文字数`)
};

const hi_live_caption_max_chars = /** @type {(inputs: Live_Caption_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रति पंक्ति अधिकतम वर्ण`)
};

const pt_pt2_live_caption_max_chars = /** @type {(inputs: Live_Caption_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de caracteres por linha`)
};

/**
* | output |
* | --- |
* | "Max characters per line" |
*
* @param {Live_Caption_Max_CharsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_max_chars = /** @type {((inputs?: Live_Caption_Max_CharsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Max_CharsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_max_chars(inputs)
	if (locale === "de") return de_live_caption_max_chars(inputs)
	if (locale === "it") return it_live_caption_max_chars(inputs)
	if (locale === "ru") return ru_live_caption_max_chars(inputs)
	if (locale === "es") return es_live_caption_max_chars(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_max_chars(inputs)
	if (locale === "ja") return ja_live_caption_max_chars(inputs)
	if (locale === "hi") return hi_live_caption_max_chars(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_max_chars(inputs)
	return en_live_caption_max_chars(inputs)
});